angular.module('task-project')
.component('taskProjectLink', {
    bindings: {
        item: '<',
        onClick: '&'
    },
    template: `
        <a href ng-click="$ctrl.show($ctrl.item.id)" class="project-style" style="font-weight: 400">{{$ctrl.item.name}}</a>
    `,
    controller(TaskProjectService) {
        this.show = (id) => {
            if(angular.isFunction(this.onClick())){
                return this.onClick()(id)
            }
            return TaskProjectService.show(id)
        }
    }
})
